import { invariant } from './invariant'

export class PageRegistry {
  /**
   * @type {Map<string, string>}
   * @private
   */
  _pages = new Map()

  /**
   * @param {string} pageLocation - The location of the page to register.
   * @param {string} page - The page to register.
   * @returns {void}
   */
  register(pageLocation, page) {
    this._pages.set(pageLocation, page)
  }

  /**
   * @param {string} pageLocation - The location of the page to retrieve.
   * @returns {string} The page registered at the given location.
   * @throws {Error} Throws an error if the page with the given location is not registered.
   */
  retrieve(pageLocation) {
    invariant(
      this._pages.has(pageLocation),
      `Page with location: ${pageLocation} is not registered`,
    )

    return this._pages.get(pageLocation)
  }
}
